import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { UserEntity } from '../../../../entities/utilisateur.entity';
import { ORANGE } from '../../../../shared/colors';
import { updatePassword } from '../network';

export const PasswordForm = ({
  user,
  setShowDrawer,
}: {
  user: UserEntity;
  setShowDrawer: (b: boolean) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');

  return (
    <div>
      <Form
        layout='vertical'
        style={{ listStyleType: 'none' }}
        form={form}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        initialValues={{ password, confirm }}
        onFinish={async (data) => {
          setIsLoading(true);
          const { password } = data;

          if (user) {
            await updatePassword(user.url, password).then(
              ({ data, statusCode }) => {
                if (statusCode?.toString()[0] === '2') {
                  notification.success({
                    message: 'Succès',
                    description:
                      'Le mot de passe a été réinitialisé avec succès',
                  });
                  setShowDrawer(false);
                  setPassword('');
                  setConfirm('');
                } else {
                  notification.info({
                    message: 'Erreur',
                    description: data.message || statusCode,
                  });
                }
                setIsLoading(false);
              },
            );
          }
        }}
      >
        <Form.Item
          label='Mot de passe'
          name='password'
          rules={[
            {
              required: true,
              message: 'Entrez votre mot de passe!',
            },
          ]}
        >
          <Input.Password placeholder='Entrer le nouveau mot de passe' />
        </Form.Item>

        <Form.Item
          label='Confirmer mot de passe'
          name='confirm'
          dependencies={['password']}
          rules={[
            {
              required: true,
              message: 'Veuillez confirmer votre mot de passe!',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    'Les deux mots de passe que vous avez saisis ne correspondent pas!',
                  ),
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder='Confirmer le nouveau mot de passe' />
        </Form.Item>

        <Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            // size='large'
            loading={isLoading}
            style={{
              width: '50%',
              backgroundColor: ORANGE,
              borderWidth: 0,
              borderRadius: 5,
              marginBottom: 20,
              marginTop: 15,
            }}
          >
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
